import KindergartenRow from './KindergartenRow'

export default KindergartenRow
